import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import ModalFooter from 'react-bootstrap/ModalFooter';
import ModalHeader from '../../../../components/ModalHeader';
import Button from '../../../../components/Button';
import { Container, Col, Row } from 'react-bootstrap';
import Avatar, {
  AvatarSize,
  AvatarStatus,
} from './../../../../components/Avatar';
import { capitalizeFirstLetter } from '../../../../utils/utils';
import { getAllProfiles } from '../../../../services/profiles';

export type CustomRetireSummaryModalProps = React.PropsWithoutRef<{
  showRetireSummaryModal: boolean;
  handleCloseRetireSummaryModal: () => void;
}>;

const RetireSummaryModal = ({
  showRetireSummaryModal,
  handleCloseRetireSummaryModal,
}: CustomRetireSummaryModalProps) => {
  const primaryProfile = getAllProfiles().data.filter(
    (profile) => profile.relationship === 'spouse'
  )[0];

  const secondaryProfiles = getAllProfiles().data.filter(
    (profile) => profile.id === '3' || profile.id === '4'
  );

  const secondaryProfilesFraction = `${(100 / secondaryProfiles.length)
    .toFixed(2)
    .replace(/\.00/, '')}%`;

  return (
    <>
      <Modal
        show={showRetireSummaryModal}
        onHide={handleCloseRetireSummaryModal}
        size={'xl'}
      >
        <ModalHeader closeButton>
          <h4>Retire Online Summary</h4>
        </ModalHeader>
        <ModalBody>
          <Container>
            <Row>
              <Col className="fs-6 fw-light ps-0">Information</Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-6 pe-lg-11">
                <Row>
                  <Col className="text-fs-6 pt-11 pb-3 ps-0">
                    Retirement Information
                  </Col>
                </Row>
                <Row className="text-fs-6 fw-light pt-3 lh-xs border-top">
                  <Col className="text-ligther-grey ps-0">
                    When is your last day of work?
                  </Col>
                  <Col className="text-end pe-0">04/01/2034</Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-4">
                  <Col className="text-ligther-grey ps-0">
                    When do you want to begin receiving pension benefits?
                  </Col>
                  <Col className=" text-end pe-0">04/01/2034</Col>
                </Row>
              </Col>
              <Col className=" col-12 col-lg-6 ps-lg-11">
                <Row>
                  <Col className="text-fs-6 pt-11 pt-3 pb-3 ps-0">
                    Beneficiary Information
                  </Col>
                </Row>
                <Row className="text-fs-6 fw-light pt-3 lh-xs border-top">
                  <Col className="text-ligther-grey ps-0">Status</Col>
                  <Col className="text-end pe-0">Married</Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-4">
                  <Col className="text-ligther-grey ps-0">
                    Beneficiary Designation
                  </Col>
                  <Col className="text-end pe-0">Pat Smith</Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-4">
                  <Col className="text-ligther-grey ps-0">Spouse DOB</Col>
                  <Col className="text-end pe-0">07/30/1979</Col>
                </Row>
              </Col>
            </Row>
            {/* Selected options */}
            <Row>
              <Col className="fs-6 fw-light pt-11 ps-0">Selected Options</Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6 pe-lg-11">
                <Row className="border-bottom">
                  <Col className="text-fs-6 pt-11 pb-3 ps-0">
                    Qualified Plan
                  </Col>
                  <Col className="text-caption pt-11 pb-3  text-ligther-grey fw-light text-end">
                    Benefit Amount
                  </Col>
                  <Col className="text-caption pt-11 pb-3 pe-0 text-ligther-grey fw-light text-end">
                    Beneficiary
                  </Col>
                </Row>

                <Row className="text-fs-6 fw-light lh-xs pt-4">
                  <Col className="text-ligther-grey ps-0">Single Life</Col>
                  <Col className="text-end">$59,493.60</Col>
                  <Col className="text-end pe-0">None</Col>
                </Row>
              </Col>
              <Col className=" col-12 col-lg-6 ps-lg-11">
                <Row className="border-bottom ">
                  <Col className="text-fs-6 pt-11 pb-3 ps-0">
                    Non-Qualified Plan
                  </Col>
                </Row>

                <Row className="text-fs-6 fw-light lh-xs pt-4">
                  <Col className="text-ligther-grey ps-0">50% Joint & Survivor</Col>
                  <Col className="text-end">$455.62</Col>
                  <Col className="text-end pe-0">$227.81</Col>
                </Row>
              </Col>

              <Col className=" col-12 col-lg-6 pe-lg-11">
                <Row className="border-bottom">
                  <Col className="text-fs-6 pt-11 pb-3 ps-0">
                    Cash Balance Plan
                  </Col>
                </Row>

                <Row className="text-fs-6 fw-light lh-xs pt-4">
                  <Col className="text-ligther-grey ps-0">5 Year Certain & Continuous</Col>
                  <Col className="text-end">$481.29</Col>
                  <Col className="text-end pe-0">$481.29</Col>
                </Row>
              </Col>
            </Row>
            {/* Beneficiary */}
            <Row>
              <Col className="fs-6 fw-light pt-11 ps-0">Beneficiary</Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-6 pe-lg-11">
                <Row className="border-bottom">
                  <Col className="text-fs-6 pt-11 pb-3 ps-0">Primary</Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-4">
                  <Col className="ps-0">
                    <Row>
                      <Col className="col-4 col-lg-3">
                        <Avatar
                          id={primaryProfile.id}
                          status={AvatarStatus.ENABLED}
                          size={AvatarSize.MEDIUM}
                          name={`${primaryProfile.firstName} ${primaryProfile.lastName}`}
                        />
                      </Col>
                      <Col>
                        <div>{`${primaryProfile.firstName} ${primaryProfile.lastName}`}</div>
                        <div className="text-ligther-grey">
                          {capitalizeFirstLetter(primaryProfile.relationship)}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col className="text-end text-indigo pe-0">100%</Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-6 ps-lg-11">
                <Row className="border-bottom ">
                  <Col className="text-fs-6 pt-11 pb-3 ps-0">Contingent</Col>
                </Row>
                {secondaryProfiles.map((profile, index) => {
                  return (
                    <Row key={index} className="text-fs-6 fw-light lh-xs pt-4">
                      <Col className="ps-0">
                        <Row>
                          <Col className="col-4 col-lg-3 pe-0">
                            <Avatar
                              id={profile.id}
                              status={AvatarStatus.ENABLED}
                              size={AvatarSize.MEDIUM}
                              name={`${profile.firstName} ${profile.lastName}`}
                            />
                          </Col>
                          <Col>
                            <div>{`${profile.firstName} ${profile.lastName}`}</div>
                            <div className="text-ligther-grey">
                              {capitalizeFirstLetter(profile.relationship)}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col className="text-end text-indigo pe-0">
                        {secondaryProfilesFraction}
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>
            {/* Direct Deposit */}
            <Row>
              <Col className="fs-6 fw-light pt-11 ps-0">Direct Deposit</Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-8 pe-11">
                <Row className="border-bottom">
                  <Col className="text-fs-6 pt-11 pb-3 ps-0">Main Account</Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-4">
                  <Col className="ps-0">
                    <Row>
                      <Col className="col-2 col-lg-1">
                        <Avatar
                          id={'4'}
                          status={AvatarStatus.ENABLED}
                          size={AvatarSize.MEDIUM}
                          name={'W F'}
                        />
                      </Col>
                      <Col>
                        <div>Checking *****6789</div>
                        <div className="text-ligther-grey">
                          Wells Fargo Bank
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* Lump Sum Distribution */}
            <Row>
              <Col className="fs-6 fw-light pt-13 ps-0">
                Lump Sum Distribution
              </Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-8 pe-11">
                <Row className="border-bottom">
                  <Col className="text-fs-6 pt-11 pb-3 ps-0">
                    Rollover to Financial Institution - All
                  </Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-4">
                  <Col className="ps-0">
                    <Row>
                      <Col className="col-2 col-lg-1">
                        <Avatar
                          id={'5'}
                          status={AvatarStatus.ENABLED}
                          size={AvatarSize.MEDIUM}
                          name={'B A'}
                        />
                      </Col>
                      {/* <Col className="pt-1 ps-6"> */}
                      <Col>
                        <div>Checking *****1234</div>
                        <div className="text-ligther-grey">Bank of America</div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* Tax Withholding */}
            <Row>
              <Col className="fs-6 fw-light pt-13 ps-0">Tax Withholding</Col>
            </Row>
            <Row>
              <Col className="col-12 pe-11">
                <Row className="border-bottom">
                  <Col className="text-fs-6 pt-11 pb-3 ps-0">
                    Federal Tax Withholding
                  </Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-3">
                  <Col className="text-ligther-grey ps-0">Plan</Col>
                  <Col>Company Pension Plan</Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-3">
                  <Col className="text-ligther-grey ps-0">
                    How much you're withholding per check?
                  </Col>
                  <Col className="text-ligther-grey">
                    Calculate based on Head of Household, $45.00 Dependent
                    Credits, $5.00 Other Income, $4.00 Deductions, and $2.00
                    Extra Withholding.
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col className="col-12 pe-11">
                <Row className="border-bottom">
                  <Col className="text-fs-6 pt-13 pb-3 ps-0">
                    State Tax Withholding
                  </Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-3">
                  <Col className="text-ligther-grey ps-0">Plan</Col>
                  <Col>Company Pension Plan</Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-3">
                  <Col className="text-ligther-grey ps-0">State</Col>
                  <Col>VA</Col>
                </Row>
                <Row className="text-fs-6 fw-light lh-xs pt-3">
                  <Col className="text-ligther-grey ps-0">
                    How much you're withholding per check?
                  </Col>
                  <Col className="text-ligther-grey">
                    Calculate based on Single with 2 allowances plus an
                    additional $33.00.
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary-outline"
            onClick={handleCloseRetireSummaryModal}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default RetireSummaryModal;
